var _style, _rect, _polygon, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeysBright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000175287029365795544010000014280272268399798719_);}\n\t.st3{fill:url(#SVGID_00000036232953019705632740000008623913622475262628_);}\n\t.st4{fill:url(#SVGID_00000087371347803731471280000010579416017794657448_);}\n\t.st5{fill:url(#SVGID_00000166673376058917049180000016601941242111498914_);}\n\t.st6{fill:#A7A7A7;}\n\t.st7{fill:url(#SVGID_00000124858683717286333470000015239021151257958800_);}\n\t.st8{fill:url(#SVGID_00000088112751500064942020000014957033193229503163_);}\n\t.st9{fill:url(#SVGID_00000111899863754044999880000009432476912251158944_);}\n\t.st10{fill:url(#SVGID_00000032633380135683709390000016277289172659249805_);}\n\t.st11{fill:url(#SVGID_00000027590232479151631830000004513626671512931481_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 80,
    height: 80
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.8038,
    y1: 1767.7,
    x2: 56.0544,
    y2: 1778.5245,
    gradientTransform: "matrix(1 0 0 1 0 -1700.426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "43.5,70.9 49.8,67.4 62.3,74.4 56.1,78.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112604035739237527150000001424998291566762406_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.1086,
    y1: 146.9095,
    x2: 59.1086,
    y2: 39.6863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D8D8D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000112604035739237527150000001424998291566762406_)"
    },
    points: "62.3,69.5 62.3,34.6 55.9,35.9  55.9,73.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105404348399814687820000011370018011129468059_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.4803,
    y1: 9.4363,
    x2: 71.0151,
    y2: 26.4889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D8D8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105404348399814687820000011370018011129468059_)"
    },
    d: "M64.1,27.2c0-9-10.4-25.5-20.6-21.4 c1-0.3,5.9-3.9,7.1-4c5-1.1,9.6,2.6,12.8,6.1c5.1,5.8,10.8,19.1,3.2,24.6l-6.1,3.5C63,34.8,64.4,31.1,64.1,27.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177471906254606217700000016401682392863210409_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2055,
    y1: 63.9051,
    x2: 52.2055,
    y2: -4.1493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#E0E0E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177471906254606217700000016401682392863210409_)"
    },
    d: "M52.4,6.8C45.6,2.8,40,6,40,13.7 c0,6.1,3.4,13.2,7.9,17.8v6.7L52,43h-4.2v4.7l4.2,4.5h-4.2v4.8l4.2,4.5h-4.2v2.7l8,9V36.6c5,1,8.5-2.2,8.5-8.5 C64.6,20.2,59.1,10.7,52.4,6.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062150815249867545050000003253287878944927930_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.1403,
    y1: -590.0815,
    x2: 52.922,
    y2: -606.8618,
    gradientTransform: "matrix(1 0 0 -1 0 -588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D8D8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062150815249867545050000003253287878944927930_)"
    },
    d: "M51.4,12.3c-2.1-1.1-3.5-0.2-3.7,2.2 c0,2.4,1.6,5.5,3.5,6.6c1.9,1.3,3.5,0.2,3.5-2.2C54.9,16.5,53.3,13.6,51.4,12.3z"
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "54.8,71.9 53.8,70.8 53.8,39.9 54.8,40.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163763543448197734380000001535280161537839797_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6425,
    y1: 1767.7,
    x2: 29.893,
    y2: 1778.5245,
    gradientTransform: "matrix(1 0 0 1 0 -1700.426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000163763543448197734380000001535280161537839797_)"
    },
    points: "17.4,70.9 23.6,67.4 36.2,74.4  29.9,78.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021085675599054139240000004100599951895235714_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.9472,
    y1: 146.9095,
    x2: 32.9472,
    y2: 39.6863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D8D8D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000021085675599054139240000004100599951895235714_)"
    },
    points: "36.2,69.5 36.2,34.6 29.7,35.9  29.7,73.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152949783961950330210000005731444950779540365_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.319,
    y1: 9.4363,
    x2: 44.8537,
    y2: 26.4889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D8D8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152949783961950330210000005731444950779540365_)"
    },
    d: "M37.9,27.2c0-9-10.4-25.5-20.6-21.4 c1-0.3,5.9-3.9,7.1-4c5-1.1,9.6,2.6,12.8,6.1c5.1,5.8,10.8,19.1,3.2,24.6l-6.1,3.5C36.8,34.8,38.2,31.1,37.9,27.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159453702986658406200000006163706282116356759_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.0442,
    y1: 63.9051,
    x2: 26.0442,
    y2: -4.1493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#E0E0E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159453702986658406200000006163706282116356759_)"
    },
    d: "M26.2,6.8c-6.7-4-12.4-0.8-12.4,6.9 c0,6.1,3.4,13.2,7.9,17.8v6.7l4.2,4.7h-4.2v4.7l4.2,4.5h-4.2v4.8l4.2,4.5h-4.2v2.7l8,9V36.6c5,1,8.5-2.2,8.5-8.5 C38.4,20.2,32.9,10.7,26.2,6.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166643126938170734570000002697658114385273521_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.979,
    y1: -590.0815,
    x2: 26.7606,
    y2: -606.8618,
    gradientTransform: "matrix(1 0 0 -1 0 -588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D8D8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166643126938170734570000002697658114385273521_)"
    },
    d: "M25.2,12.3c-2.1-1.1-3.5-0.2-3.7,2.2 c0,2.4,1.6,5.5,3.5,6.6c1.9,1.3,3.5,0.2,3.5-2.2C28.8,16.5,27.2,13.6,25.2,12.3z"
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "28.6,71.9 27.6,70.8 27.6,39.9 28.6,40.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeysBright);
export default __webpack_public_path__ + "static/media/keys-bright.6a66cd0f8dee385ce5f22a798fcd809f.svg";
export { ForwardRef as ReactComponent };